/** Raise a QC Sampling Request on the desk (manual p126–127). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { QcRequestNewPage } from "@/features/quality/components/requests/qc-request-new-page";

export const Route = createFileRoute("/_app/quality/requests/new")({
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.request")) throw redirect({ to: "/" });
  },
  component: QcRequestNewPage,
});
